<div class="flex gap-4 items-start w-full overflow-hidden">
  <!-- ─── Main Card: filters + chart ───────────────────────────── -->
  <div class="flex-1 min-w-0 bg-white rounded-2xl border border-gray-200 shadow-sm flex flex-col h-[calc(100vh-180px)]">
    <!-- Header -->
    <div class="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
      <div class="flex items-center gap-3">
        <div class="w-9 h-9 rounded-lg bg-blue-50 flex items-center justify-center">
          <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
        </div>
        <div>
          <h2 class="text-base font-bold text-gray-900">My Reporting</h2>
          <p class="text-xs text-gray-500">Overview of my time entries by period</p>
        </div>
      </div>
    </div>

    @if (loading) {
    <div class="py-24 text-center">
      <div class="w-10 h-10 rounded-full border-4 border-blue-100 border-t-blue-600 animate-spin mx-auto mb-4"></div>
      <p class="text-gray-500 text-sm">Loading report…</p>
    </div>
    } @else {

    <!-- Filters Bar -->
    <div class="px-6 py-4 border-b border-gray-100">
      <div class="flex flex-wrap items-end gap-4">
        <div class="min-w-[160px]">
          <label class="block text-[11px] font-semibold text-gray-400 uppercase tracking-wide mb-1.5">Status</label>
          <div class="relative">
            <select [(ngModel)]="approvalStatusFilter" (change)="onFilterChange()" class="w-full appearance-none px-3 py-2 pr-8 rounded-lg text-sm bg-white border border-gray-200
                   focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 hover:border-gray-300 outline-none cursor-pointer transition-all">
              <option value="">All</option>
              <option value="DRAFT">Not approved</option>
              <option value="APPROVED">Approved</option>
            </select>
            <svg class="absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>
        <div class="project-filter-container min-w-[220px] relative">
          <label class="block text-[11px] font-semibold text-gray-400 uppercase tracking-wide mb-1.5">Project / Task</label>
          <button type="button" (click)="toggleProjectDropdown()" class="w-full flex items-center justify-between gap-2 px-3 py-2 rounded-lg text-sm bg-white border border-gray-200
                 hover:border-gray-300 focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 outline-none cursor-pointer transition-all text-left">
            <span class="flex items-center gap-2 min-w-0">
              <svg class="w-3.5 h-3.5 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
              </svg>
              @if (selectedProjects.size === 0) {
              <span class="text-gray-400 truncate">All projects</span>
              } @else if (selectedProjects.size === 1) {
              <span class="text-gray-800 truncate">{{ resolveKeyName(selectedProjects.values().next().value ?? '') }}</span>
              } @else {
              <span class="text-gray-800 truncate">{{ selectedProjects.size }} projects</span>
              }
            </span>
            <div class="flex items-center gap-1.5 flex-shrink-0">
              @if (selectedProjects.size > 0) {
              <span class="inline-flex items-center justify-center w-4 h-4 text-[10px] font-bold rounded-full bg-blue-600 text-white">{{ selectedProjects.size }}</span>
              <button type="button" (click)="$event.stopPropagation(); clearProjectFilter()"
                class="w-4 h-4 flex items-center justify-center rounded text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors cursor-pointer" title="Clear">
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6 18L18 6M6 6l12 12" /></svg>
              </button>
              }
              <svg class="w-4 h-4 text-gray-400 transition-transform duration-200" [class.rotate-180]="projectDropdownOpen" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </button>
          @if (projectDropdownOpen) {
          <div class="absolute top-full left-0 mt-1 w-full min-w-[240px] bg-white border border-gray-200 rounded-xl shadow-lg z-50 overflow-hidden">
            <div class="px-3 pt-3 pb-2 border-b border-gray-100">
              <input type="text" [(ngModel)]="projectSearch" placeholder="Search…" class="w-full pl-3 pr-3 py-1.5 rounded-lg text-sm bg-gray-50 border border-gray-200 focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 outline-none transition-all" />
            </div>
            <div class="max-h-52 overflow-y-auto py-1">
              @if (filteredProjectOptions.length === 0) { <div class="px-4 py-3 text-sm text-gray-400 text-center">No projects</div> }
              @for (proj of filteredProjectOptions; track proj) {
              <label class="flex items-center gap-3 px-3 py-2 hover:bg-blue-50/60 cursor-pointer transition-colors group">
                <div class="relative flex-shrink-0">
                  <input type="checkbox" [checked]="selectedProjects.has(proj)" (change)="toggleProject(proj)" class="sr-only" />
                  <div class="w-4 h-4 rounded border-2 flex items-center justify-center transition-all"
                    [class]="selectedProjects.has(proj) ? 'bg-blue-600 border-blue-600' : 'border-gray-300 bg-white group-hover:border-blue-400'">
                    @if (selectedProjects.has(proj)) {
                    <svg class="w-2.5 h-2.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" /></svg>
                    }
                  </div>
                </div>
                <span class="text-sm truncate" [class]="selectedProjects.has(proj) ? 'text-blue-700 font-medium' : 'text-gray-700'">{{ resolveKeyName(proj) }}</span>
              </label>
              }
            </div>
          </div>
          }
        </div>
        <div class="flex items-center gap-2 py-2">
          <span class="text-xs bg-gray-100 text-gray-600 px-2.5 py-1 rounded-lg font-medium">{{ allEntries.length }} entries</span>
        </div>
      </div>
    </div>

    <!-- Period Selector -->
    <div class="px-6 py-3 border-b border-gray-100 flex items-center justify-between gap-3 flex-wrap">
      <div class="flex items-center gap-1 bg-gray-100 rounded-lg p-0.5">
        <button (click)="setPeriod('day')" class="px-3 py-1.5 rounded-md text-xs font-semibold transition-all cursor-pointer" [class]="periodMode === 'day' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'">Day</button>
        <button (click)="setPeriod('week')" class="px-3 py-1.5 rounded-md text-xs font-semibold transition-all cursor-pointer" [class]="periodMode === 'week' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'">Week</button>
        <button (click)="setPeriod('month')" class="px-3 py-1.5 rounded-md text-xs font-semibold transition-all cursor-pointer" [class]="periodMode === 'month' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'">Month</button>
        <button (click)="setPeriod('quarter')" class="px-3 py-1.5 rounded-md text-xs font-semibold transition-all cursor-pointer" [class]="periodMode === 'quarter' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'">Quarter</button>
        @if (canShowAllPeriod) {
        <button (click)="setPeriod('all')" class="px-3 py-1.5 rounded-md text-xs font-semibold transition-all cursor-pointer" [class]="periodMode === 'all' ? 'bg-blue-600 text-white shadow-sm' : 'text-gray-500 hover:text-gray-700'">All</button>
        }
      </div>
      <div class="flex items-center gap-2">
        @if (periodMode !== 'all') {
        <button (click)="navigatePeriod(-1)" class="p-1.5 rounded-lg text-gray-400 hover:text-gray-700 hover:bg-gray-100 transition-all cursor-pointer">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" /></svg>
        </button>
        <button (click)="goToToday()" class="px-3 py-1 rounded-lg text-xs font-semibold text-emerald-700 bg-emerald-50 border border-emerald-200 hover:bg-emerald-100 transition-all cursor-pointer">Today</button>
        }
        <span class="text-sm font-semibold text-gray-800 min-w-[130px] text-center">{{ periodLabel }}</span>
        @if (periodMode !== 'all') {
        <button (click)="navigatePeriod(1)" class="p-1.5 rounded-lg text-gray-400 hover:text-gray-700 hover:bg-gray-100 transition-all cursor-pointer">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" /></svg>
        </button>
        }
      </div>
    </div>

    <!-- Chart -->
    <div class="flex-1 min-h-0 flex flex-col px-6 py-5">
      <div class="flex items-stretch gap-2 flex-1 min-h-0">
        <!-- Y axis -->
        <div class="flex flex-col justify-between h-full pr-1 pb-[28px] flex-shrink-0">
          @for (label of yAxisLabels; track label) {
          <span class="text-[10px] text-gray-400 font-mono leading-none text-right w-6">{{ label }}h</span>
          }
        </div>
        <!-- Bars -->
        <div class="flex-1 min-w-0 min-h-0" [class.overflow-x-auto]="chartMinWidth" [class.overflow-visible]="!chartMinWidth">
          <div class="flex items-stretch gap-5 h-full" [style.min-width.px]="chartMinWidth" [class.w-full]="!chartMinWidth">
          @for (bucket of dayBuckets; track bucket.dateKey) {
          @let isCurrent = bucket.dateKey === currentBucketKey;
          @let isSelected = selectedDay?.dateKey === bucket.dateKey;
          <div class="flex-1 flex flex-col items-center h-full cursor-pointer group relative z-0 hover:z-30"
            [style.min-width.px]="chartMinWidth ? 40 : null"
            (click)="selectDay(bucket)" [class.opacity-40]="isWeekend(bucket) && bucket.totalHours === 0">
            <!-- Tooltip -->
            <!-- Anchor the tooltip to the bar's left/right edge near the chart ends: a
                 260px-wide tooltip centred on a ~40px bar overflows the interface there. -->
            <div class="absolute bottom-full mb-2 px-3 py-2 bg-gray-900 text-white text-[10px] rounded-lg
                      opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-[100] shadow-xl max-w-[260px] w-max"
              [ngClass]="$index <= 1 ? 'left-0' : ($index >= $count - 2 ? 'right-0' : 'left-1/2 -translate-x-1/2')">
              <div class="font-semibold mb-0.5">{{ bucket.label }}</div>
              <div class="mb-1">Total: {{ formatHours(bucket.totalHours) }}</div>
              @for (seg of bucket.projectSegments; track seg.name) {
              <div class="flex items-center gap-1.5">
                <div class="w-2 h-2 rounded-full flex-shrink-0" [style.background-color]="seg.color"></div>
                <span class="truncate">{{ seg.name.length > 35 ? seg.name.slice(0, 35) + '…' : seg.name }}</span>
                <span class="flex-shrink-0 font-semibold">{{ formatHours(seg.hours) }}</span>
              </div>
              }
              <div class="text-gray-400 mt-1 border-t border-gray-700 pt-1">{{ bucket.entries.length }} entries</div>
            </div>
            <!-- Bar track (value label + bar, bottom-aligned) -->
            <div class="flex-1 w-full flex flex-col items-center justify-end min-h-0">
              @if (bucket.totalHours > 0) {
              <span class="text-[11px] font-bold mb-1 leading-none shrink-0" [class.text-blue-400]="isCurrent" [class.text-gray-900]="!isCurrent">{{ bucket.totalHours | number:'1.0-0' }}h</span>
              }
              <div class="w-full max-w-[48px] rounded-t-md transition-all duration-200 group-hover:opacity-90 shrink-0"
                [style.height.%]="getBarPercent(bucket.totalHours)"
                [class.bg-blue-300]="isCurrent && !isSelected"
                [class.bg-blue-600]="!isCurrent && !isSelected"
                [class.bg-blue-700]="isSelected"></div>
            </div>
            <!-- X label -->
            <span class="text-[10px] mt-1.5 font-medium leading-none truncate w-full text-center shrink-0"
              [class.text-blue-600]="isCurrent || isSelected" [class.font-bold]="isCurrent || isSelected"
              [class.text-gray-400]="!isCurrent && !isSelected">{{ bucket.label }}</span>
          </div>
          }
          </div>
        </div>
      </div>
      <!-- Caption -->
      <div class="flex items-center gap-2 mt-4 pl-10">
        <div class="w-3 h-3 rounded-sm bg-blue-600"></div>
        <span class="text-[11px] text-gray-500">Hours logged · {{ periodLabel }}</span>
      </div>
    </div>
    }
  </div>

  <!-- ─── Summary Sidebar (separate column) ─────────────────────── -->
  @if (!loading) {
  <div class="w-[280px] flex-shrink-0 flex flex-col gap-3 h-[calc(100vh-180px)] overflow-y-auto pr-0.5">
    <h3 class="text-[11px] font-semibold text-gray-400 uppercase tracking-wider px-1">Summary</h3>

    <!-- Stat cards -->
    <div class="grid grid-cols-2 gap-2.5">
      <div class="bg-white rounded-xl border border-gray-200 p-3 shadow-sm">
        <div class="text-[10px] text-gray-400 uppercase tracking-wide font-semibold mb-1">Today</div>
        <div class="text-lg font-bold text-gray-900">{{ formatHoursShort(todayHours) }}</div>
      </div>
      <div class="bg-white rounded-xl border border-gray-200 p-3 shadow-sm">
        <div class="text-[10px] text-gray-400 uppercase tracking-wide font-semibold mb-1">Week</div>
        <div class="text-lg font-bold text-gray-900">{{ formatHoursShort(weekHours) }}</div>
        <div class="text-[10px] font-semibold mt-0.5" [class]="weekHours >= weekTarget ? 'text-emerald-600' : 'text-orange-500'">{{ weekHours >= weekTarget ? '▲' : '▼' }} {{ formatPercent(weekHours, weekTarget) }}</div>
      </div>
      <div class="bg-white rounded-xl border border-gray-200 p-3 shadow-sm">
        <div class="text-[10px] text-gray-400 uppercase tracking-wide font-semibold mb-1">This month</div>
        <div class="text-lg font-bold text-gray-900">{{ formatHoursShort(monthHours) }}</div>
        <div class="text-[10px] font-semibold mt-0.5" [class]="monthHours >= monthTarget ? 'text-emerald-600' : 'text-orange-500'">{{ monthHours >= monthTarget ? '▲' : '▼' }} {{ formatPercent(monthHours, monthTarget) }}</div>
      </div>
      <div class="bg-white rounded-xl border border-gray-200 p-3 shadow-sm">
        <div class="text-[10px] text-gray-400 uppercase tracking-wide font-semibold mb-1">Period</div>
        <div class="text-lg font-bold text-gray-900">{{ formatHoursShort(totalHours) }}</div>
        <div class="text-[10px] text-gray-500 mt-0.5">{{ allEntries.length }} entries</div>
      </div>
    </div>

    <!-- Approval -->
    <div class="bg-white rounded-xl border border-gray-200 p-3.5 shadow-sm">
      <div class="text-[10px] text-gray-400 uppercase tracking-wide font-semibold mb-2.5">Approval</div>
      <div class="w-full h-2 bg-gray-100 rounded-full overflow-hidden mb-3 flex">
        <div class="h-full bg-emerald-500 transition-all duration-500" [style.width.%]="totalHours > 0 ? (approvedTotal / totalHours * 100) : 0"></div>
        <div class="h-full bg-orange-400 transition-all duration-500" [style.width.%]="totalHours > 0 ? (draftTotal / totalHours * 100) : 0"></div>
      </div>
      <div class="flex items-center justify-between text-[11px] mb-1">
        <span class="flex items-center gap-1.5"><span class="w-2 h-2 rounded-full bg-emerald-500"></span><span class="text-gray-600">Approved</span></span>
        <span class="font-semibold text-gray-900">{{ formatHoursShort(approvedTotal) }}</span>
      </div>
      <div class="flex items-center justify-between text-[11px]">
        <span class="flex items-center gap-1.5"><span class="w-2 h-2 rounded-full bg-orange-400"></span><span class="text-gray-600">Pending</span></span>
        <span class="font-semibold text-gray-900">{{ formatHoursShort(draftTotal) }}</span>
      </div>
    </div>

    <!-- By project -->
    <div class="bg-white rounded-xl border border-gray-200 p-3.5 shadow-sm flex flex-col min-h-0 flex-1">
      <div class="flex items-center justify-between mb-2.5 flex-shrink-0">
        <div class="text-[10px] text-gray-400 uppercase tracking-wide font-semibold">By project</div>
        @if (selectedDay) { <span class="text-[10px] text-blue-600 font-medium">{{ selectedDay.label }}</span> }
      </div>
      @if (projectBreakdowns.length === 0) { <p class="text-xs text-gray-400 italic">No data</p> }
      <div class="space-y-2.5 overflow-y-auto min-h-0 flex-1">
        @for (pb of projectBreakdowns; track pb.name) {
        <div>
          <div class="flex items-center justify-between mb-1">
            <div class="flex items-center gap-1.5 min-w-0 flex-1">
              <div class="w-2 h-2 rounded-full flex-shrink-0" [style.background-color]="pb.color"></div>
              <span class="text-[12px] font-medium text-gray-700 truncate">{{ pb.name }}</span>
            </div>
            <span class="text-[12px] font-semibold text-gray-900 flex-shrink-0 ml-2">{{ formatHoursShort(pb.hours) }}</span>
          </div>
          <div class="w-full h-1 bg-gray-100 rounded-full overflow-hidden">
            <div class="h-full rounded-full transition-all duration-300" [style.width.%]="totalHours > 0 ? (pb.hours / totalHours * 100) : 0" [style.background-color]="pb.color"></div>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
  }

  <!-- ─── Detail Panel ──────────────────────────────────────────── -->
  @if (selectedDay) {
  <div @slidePanel
    class="w-[320px] flex-shrink-0 bg-white rounded-2xl border border-gray-200 shadow-sm flex flex-col self-stretch overflow-hidden h-[calc(100vh-180px)]">
    <div class="px-4 py-3 bg-blue-50/80 border-b border-blue-100 rounded-t-2xl flex items-center justify-between flex-shrink-0">
      <div class="flex items-center gap-2.5">
        <div class="w-7 h-7 rounded-lg bg-blue-100 flex items-center justify-center">
          <svg class="w-3.5 h-3.5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </div>
        <div>
          <h3 class="text-sm font-semibold text-gray-900">Entries</h3>
          <p class="text-[11px] text-gray-500">{{ selectedDay.label }} · {{ selectedDay.entries.length }} entries · {{ formatHoursShort(selectedDay.totalHours) }}</p>
        </div>
      </div>
      <button (click)="clearDaySelection()" class="p-1.5 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-white/80 cursor-pointer transition-all">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" /></svg>
      </button>
    </div>
    <div class="px-4 py-2 border-b border-gray-100 bg-gray-50/60 flex items-center gap-4 flex-shrink-0">
      <div class="flex items-center gap-1.5"><div class="w-2 h-2 rounded-full bg-emerald-500"></div><span class="text-[10px] text-gray-600">Approved <span class="font-semibold">{{ formatHoursShort(selectedDay.approvedHours) }}</span></span></div>
      <div class="flex items-center gap-1.5"><div class="w-2 h-2 rounded-full bg-orange-400"></div><span class="text-[10px] text-gray-600">Draft <span class="font-semibold">{{ formatHoursShort(selectedDay.draftHours) }}</span></span></div>
    </div>
    <div class="flex-1 overflow-y-auto">
      @for (entry of selectedDay.entries; track entry.id) {
      <div class="px-4 py-3 border-b border-gray-100 hover:bg-blue-50/30 transition-colors">
        <div class="flex items-center gap-1.5 mb-1.5">
          @if ((entry.approvalStatus ?? 'DRAFT') === 'APPROVED') {
          <span class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[9px] font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200"><span class="w-1 h-1 rounded-full bg-emerald-500"></span>Approved</span>
          } @else {
          <span class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[9px] font-semibold bg-gray-100 text-gray-600 border border-gray-200"><span class="w-1 h-1 rounded-full bg-gray-400"></span>Draft</span>
          }
        </div>
        <div class="flex items-center gap-1.5 mb-1">
          @if (getEntryType(entry.projectName) === 'CRM Task') {
          <span class="inline-flex items-center px-1 py-0.5 rounded text-[8px] font-medium bg-purple-50 text-purple-700 border border-purple-100">Task</span>
          } @else {
          <span class="inline-flex items-center px-1 py-0.5 rounded text-[8px] font-medium bg-blue-50 text-blue-700 border border-blue-100">Proj</span>
          }
          <span class="text-xs font-medium text-gray-800 truncate">{{ getEntryName(entry.projectName) }}</span>
        </div>
        <div class="flex items-center gap-3 text-[11px] text-gray-500">
          <span class="font-mono">{{ entry.startTime | date:'HH:mm' }} → {{ entry.endTime | date:'HH:mm' }}</span>
          <span class="font-semibold text-gray-700">{{ getDuration(entry.startTime, entry.endTime) }}</span>
          @if (entry.billable ?? true) { <span class="text-emerald-600">€</span> }
        </div>
        @if (entry.content) { <p class="text-[11px] text-gray-400 mt-1 line-clamp-1" [title]="entry.content">{{ entry.content }}</p> }
      </div>
      } @empty {
      <div class="px-4 py-12 text-center">
        <svg class="w-8 h-8 text-gray-300 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
        <p class="text-gray-400 text-xs">No entries</p>
      </div>
      }
    </div>
  </div>
  }
</div>
